export default __webpack_public_path__ + "static/media/gallery-wip-handle_00.5942c0c5.jpg";